<app-bread-crumb [items]="[{text:'produtos'}]" [sectionTitle]="'Lista de Produtos'"></app-bread-crumb>

<section class="content">
  <div class="row">
    <div class="col-md-12">
      <ng-box [boxIcon]="'fa fa-shopping-cart'" [boxTitle]="'Produtos'">

        <ng-container class="ng-box-header">
          <ng-button 
          *ngIf="isAdmin()" 
          (click)="create()"
          [button]="{name:'novo produto', faIconClass:'fa fa-plus',color:'danger'}">
        </ng-button>
        </ng-container>

        <ng-container class="ng-box-content">

          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

            <tr *ngFor="let product of objects;index" ngChangeColorOnHover>

             <td>{{product?.product_code}}</td>

              <td>
                <strong style="font-size:medium;color:#f35309">{{product?.title}}</strong> <br>
                <small>{{product?.description}}</small>
              </td>
              <td>{{product?.category }}</td>
              <td>{{product?.subcategory }}</td>
              <td *ngIf="this.isAdminOrUserKhuzela()" [ngStyle]="{color: product?.clubColor}">{{product?.clubName }}</td>

              <!-- controles -->
              <ng-actions-table-bar>
                <ng-button   *ngIf="isAdminOrUserKhuzela()" title="Editar" (click)="edit(product)" [button]="{faIconClass:'fa fa-edit',color:'danger'}">
                </ng-button>
                <ng-button title="Detalhe" (click)="detail(product)"
                  [button]="{faIconClass:'fa fa-eye',color:'danger'}"></ng-button>
                <ng-button *ngIf="isAdmin()" title="Excluir" (click)="delete(product)"
                  [button]="{faIconClass:'fa fa-close',color:'danger'}"></ng-button>
              </ng-actions-table-bar>
            </tr>

          </ng-table>

          <!-- fim tabela -->
          <box-loading class="overlay" *ngIf="isSpinnerLoading"></box-loading>
        </ng-container>

      </ng-box>
    </div>
  </div>
</section>